import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import StatusMultipleSurtido from "../../StatusMultipleSurtido";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

function ListadoTraspasosSolicitudV2() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_TRASPASOS_SOLICITUD_V2 = process.env.REACT_APP_URL_TRASPASOS_SOLICITUD_V2;
  const URL_ARTICULOS_TSOL_V2 = process.env.REACT_APP_URL_ARTICULOS_TSOL_V2;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-90);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);

  const [areas, setAreas] = useState([]);
  const [selectedAreaSalida, setSelectedAreaSalida] = useState("");
  const [selectedAreaDestino, setSelectedAreaDestino] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [transportista, setTransportista] = useState("NA");
  const [numeroSolicitud, setNumeroSolicitud] = useState("NA");
  const [unidad, setUnidad] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [numero_traspasosSolicitud, setNumeroTraspasosSolicitud] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [surtido, setSurtido] = useState("");
  const [areaSalida, setAreaSalida] = useState("");
  const [areaDestino, setAreaDestino] = useState("");
  const [fechaModificado, setFechaModificado] = useState("");

  const [articulosTraspasosSolicitud, setArticulosTraspasosSolicitud] = useState([]);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
  const [selectedAreaSalidaEditVieja, setSelectedAreaSalidaEditVieja] = useState("");
  const [selectedAreaSalidaEdit, setSelectedAreaSalidaEdit] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalNoDisponible, setModalNoDisponible] = useState(false);
  const toggleNoDisponible = () => setModalNoDisponible(!modalNoDisponible);
  const [allArticulosAutorizar, setAllArticulosAutorizar] = useState([]);

  const [inventarios, setInventarios] = useState([]);

  const [status, setStatus] = useState("Abierto");
  const [autorizadoApartado, setAutorizadoApartado] = useState("");
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [cambiarPrecio, setCambiarPrecio] = useState(false);
  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [AbrirEditar, setAbrirEditar] = useState(false);

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_TRASPASOS_SOLICITUD_V2}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTraspasosSolicitud = response.data;
        // Array para pagination
        let arrayTabla = allTraspasosSolicitud
          .sort((a, b) => (a.idTraspasosSolicitudV2 < b.idTraspasosSolicitudV2 ? 1 : -1))
          .map((a) => {
              return {
                _id: a._id,
                numero: a.idTraspasosSolicitudV2,
                activo: a.is_active,
                fecha: a.fecha,
                observaciones: a.observaciones,
                numeroSolicitud: a.numeroSolicitud,
                subTotal: a.subTotal,
                iva: a.iva,
                total_general: a.total_general,
                total_cantidad: a.total_cantidad,
                status: a.status,
                autorizadoApartado: a.autorizadoApartado,
                autorizadoSurtido: a.autorizadoSurtido,
                impuestos: a.impuestos,
                areaSalidaName: a.areaSalida[0].name,
                idAreaSalida: a.areaSalida[0]._id,
                areaDestinoName: a.areaDestino[0].name,
                idAreaDestino: a.areaDestino[0]._id,
                surtido: a.surtido,
                fechaModificado: a.fechaModificado,
              };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

 
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get(`${URL_INVENTARIOS}Disponible`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allDisponible = response.data;
    //     setInventarios(allDisponible);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, [selectedFechaInicio, selectedFechaFin]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) 
      ) {
        return [
          a.numero,
          a.fecha,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado TraspasosSolicitud`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`TraspasosSolicitud.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) 
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoTraspasosSolicitud";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoTraspasosSolicitud",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cantidad",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cantidad",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) 
      ) {
        return [
          a.numero,
          a.fecha,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado TraspasosSolicitud",
          email: mailTo,
          fileName: "ListadoTraspasosSolicitud.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de TraspasosSolicitud.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    // fecha,
    // total_cantidad,
    // total_general,
    observaciones,
    // transportista,
    // unidad,
    // numeroSolicitud,
    // numero_traspasosSolicitud,
    numeroSolicitud,
    // impuestos,
    idEdit,
    // idAreaSalida,
  ) {


    // setFecha(fecha);
    // setTotalCantidad(total_cantidad);
    // setTotalGeneral(total_general);
    setObservaciones(observaciones);
    // setTransportista(transportista);
    // setUnidad(unidad);
    // // setNumeroSolicitud(numeroSolicitud);
    // // setNumeroTraspasosSolicitud(numero_traspasosSolicitud);
    setNumeroSolicitud(numeroSolicitud);
    // setSelectedImpuesto(impuestos);
    // setSelectedAreaSalidaEditVieja(idAreaSalida)
    // setSelectedAreaSalidaEdit(idAreaSalida)
    setIdEdit(idEdit);
    toggleEdit();
  }

  async function PDFOC(
    fecha,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    idPDFOC,
    areaSalidaName,
    areaDestinoName,
    autorizadoApartado,
    autorizadoSurtido,
    numeroSolicitud
  ) {

    await axios
      .get(`${URL_ARTICULOS_TSOL_V2}/surtir2/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosTraspasosSolicitud = response.data;
        let arrayTabla = allArticulosTraspasosSolicitud
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].SKU + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              infoAdicional: a.infoAdicional,
              surtido: a.surtido,
              precio: a.precio,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);

        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let iva_tabla = (TG * impuestos) / 100;

        const data = dataFinal.map((a) => {
          // totalParcial = a.cantidad * a.precio;
          // subTotalTabla = subTotalTabla + totalParcial
          // iva_tabla = iva_tabla + (subTotalTabla * impuesto_tabla/100)
          return [
            a.articulos,
            a.infoAdicional,
            new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(a.surtido),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({compressPdf: true});
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 8, 5, 18, 5);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 11, 20, 5);
        
        doc.setFontSize(12);
        doc.text(`Fecha:`, 35, 15);
        doc.text(`${fecha}`, 65, 15);
        doc.text(`No. Solicitud:`, 35, 20);
        doc.text(`${numero}`, 65, 20);
        doc.text(`Autorizado:`, 35, 25);
        doc.text(`${autorizadoApartado}`, 65, 25);

        doc.text(`Area Salida:`, 120, 15);
        doc.text(`${areaSalidaName}`, 150, 15);
        doc.text(`Area Destino:`, 120, 20);
        doc.text(`${areaDestinoName}`, 150, 20);
        doc.text(`Numero Solicitud:`, 120, 25);
        doc.text(`${numeroSolicitud}`, 150, 25);

        doc.setFontSize(8);
        doc.autoTable({
          head: [
            ["Articulo", "Info Adicional", "Cajas", "Cantidad", "Surtido", "Precio", "Total"],
          ],
          body: dataPDFLimpia,
          styles: {
            fontSize: 8,
            // overflow: "linebreak",
            // columnWidth: "wrap",
            // // font: 'arial',
            // overflowColumns: "linebreak",
          },
          margin: { left: 5, right: 5 },
          startY: 30,
          footStyles: {
            fontSize: 9,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
            [
              "",
              "",
              new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) + " Cajas",
              new Intl.NumberFormat("en-US").format(TK) + " Piezas",
              "",
              "Sub Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(TG),
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });

        doc.setFontSize(10);
        var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        doc.save(`TraspasosSolicitud-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editTraspasosSolicitud(event) {
    event.preventDefault();
    const URL_TRASPASOS_SOLICITUD_V2_EDIT = `${URL_TRASPASOS_SOLICITUD_V2}/${idEdit}`; 
    // const URL_AUTORIZADO = `${URL_TRASPASOS_SOLICITUD_V2}/${idEdit}`;
    // const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoApartado/${idEdit}`;
 
    // if(selectedAreaSalidaEditVieja != selectedAreaSalidaEdit){
    //   Swal.fire({
    //     title: "Estas seguro?",
    //     text: "Estas cambiando de Alamacen y se liberará el inventario!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Si, Cambiar de Almacen!",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       axios
    //         .patch(
    //           URL_AUTORIZADO,
    //           {
    //             // autorizadoApartado: "No",
    //             // autorizadoSurtido: "No",
    //             autorizoApartado: user.id,
    //             observaciones,
    //             editPedido: user.id,
    //             areaSalida:selectedAreaSalidaEdit
    //           },
    //           {
    //             headers: {
    //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //             },
    //           }
    //         )
    //         // .then((response) => {
    //         //   axios
    //         //     .patch(
    //         //       URL_AUTORIZADO_HIJO,
    //         //       {
    //         //         autorizadoApartado: "No",
    //         //         autorizadoSurtido: "No",
    //         //       },
    //         //       {
    //         //         headers: {
    //         //           Authorization: `Bearer: ${localStorage.getItem(
    //         //             "app_token"
    //         //           )}`,
    //         //         },
    //         //       }
    //         //     )
    //             .then(() => {
    //               axios.post(
    //                 URL_LOGS,
    //                 {
    //                   tipo: "Cambio Alamcen TraspasosSolicitud",
    //                   detalle: `${numero_traspasosSolicitud} ${fecha}`,
    //                   user: user.id,
    //                 },
    //                 {
    //                   headers: {
    //                     Authorization: `Bearer: ${localStorage.getItem(
    //                       "app_token"
    //                     )}`,
    //                   },
    //                 }
    //               );
    //               toggleEdit();
    //               Swal.fire("Good job!", "Actualizado con exito", "success");
    //               setTimeout(() => {
    //                 window.location.reload();
    //               }, 1000);
    //             })
    //             .catch((error) => {
    //               Swal.fire({
    //                 icon: "error",
    //                 title: "Oops...",
    //                 text: "Something went wrong!",
    //                 footer: `${error.response.data}`,
    //               });
    //               console.log(error);
    //             });
    //         // })
    //         // .catch((error) => {
    //         //   Swal.fire({
    //         //     icon: "error",
    //         //     title: "Oops...",
    //         //     text: "Something went wrong!",
    //         //     footer: `${error.response.data}`,
    //         //   });
    //         //   console.log(error);
    //         // });
    //     }
    //   });
    // }else{
    axios
      .all([
        axios.patch(
          URL_TRASPASOS_SOLICITUD_V2_EDIT,
          {
            observaciones,
            numeroSolicitud: numeroSolicitud,
            // editPedido: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar TraspasosSolicitud",
            detalle: `${numero_traspasosSolicitud} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      })
    // }
  }

  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "No. Solicitud", field: "numeroSolicitud", sortable: true },
    { name: "Almacen Salida", field: "areaSalidaName", sortable: true },
    { name: "Almacen Destino", field: "areaDestinoName", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
    { name: "Surtido", field: "surtido", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.areaSalidaName.toLowerCase().includes(search.toLowerCase()) ||
          comment.areaDestinoName.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroSolicitud.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search) 
      );
    }

  
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoSurtido.includes(autorizadoSurtido)
      );
    }
    if (autorizadoApartado) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoApartado.includes(autorizadoApartado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedAreaSalida) {
      computedComments = computedComments.filter((e) =>
        e.idAreaSalida.includes(selectedAreaSalida)
      );
    }
    if (selectedAreaDestino) {
      computedComments = computedComments.filter((e) =>
        e.idAreaDestino.includes(selectedAreaDestino)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    autorizadoApartado,
    autorizadoSurtido,
    selectedAreaSalida,
    selectedAreaDestino,
  ]);

  function EditArticulos(
    idOC,
    numero_traspasosSolicitud,
    impuestos,
    subTotal,
    iva,
    total_general,
    total_cantidad,
    surtido,
    areaSalida,
    fechaModificado
  ) {
    setSelectedImpuesto(impuestos);
    setSurtido(surtido);
    setIva(iva.toFixed(2));
    setTotalGeneralEdit(total_general);
    setTotalCantidadEdit(total_cantidad);
    setSubTotal(subTotal);
    setAreaSalida(areaSalida);
    setFechaModificado(fechaModificado)

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroTraspasosSolicitud(numero_traspasosSolicitud);
    axios
      .get(`${URL_ARTICULOS_TSOL_V2}/traspasosSolicitud/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosTraspasosSolicitud = response.data;
        let arrayTabla = allArticulosTraspasosSolicitud
          .map((a) => {
            return {
              id: a._id,
              is_active: a.is_active,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              piezasPorCaja: a.articulos[0].piezasPorCaja,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setArticulosTraspasosSolicitud(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
    setAbrirEditar(true);
  }


  const handleChangeInputExistentesPrecio = (id, event) => {
    const newArticulosTraspasosSolicitud = articulosTraspasosSolicitud.map((i) => {
      if (id === i.id) {
        i.precio = event;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosTraspasosSolicitud(newArticulosTraspasosSolicitud);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    // if (
    //   inputFields.filter((e) => e.articulos == event.target.value).length > 0 ||
    //   articulosTraspasosSolicitud.filter((e) => e.articulos == event.target.value).length >
    //     0
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "El modelo ya fue capturado!",
    //     showConfirmButton: false,
    //   });
      // const newInputFields = inputFields.map((i) => {
      //   if (id === i.id) {
      //     i.articulos = "";
      //   }
      //   return i;
      // });
      // setInputFields(newInputFields);
    // } else {
      articulos.map((a) => {
        if (a._id == event.target.value) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          handleChangeInputExistentesArticulo(id, idArticulo, piezasPorCaja);
        }
      });
    // }
  }

  const handleChangeInputExistentesArticulo = (
    id,
    idArticulo,
    piezasPorCaja
  ) => {
    const newArticulosTraspasosSolicitud = articulosTraspasosSolicitud.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosTraspasosSolicitud(newArticulosTraspasosSolicitud);
    ActualizaTotales();
  };

  // const handleChangeInputCajasExistentes = (id, event) => {
  //   const newArticulosTraspasosSolicitud = articulosTraspasosSolicitud.map((i) => {
  //     if (id === i.id) {
  //       i.cajas = event.target.value;
  //       i.cantidad =
  //         parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
  //       let totalParcial = i.cantidad * i.precio;
  //       i.total = totalParcial;
  //       i.pendiente_surtir =
  //         parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) -
  //         parseFloat(i.surtido);
  //     }
  //     return i;
  //   });
  //   setArticulosTraspasosSolicitud(newArticulosTraspasosSolicitud);
  //   ActualizaTotales();
  // };

  const handleChangeInputCantidadExistentes = (id, event) => {
    const newArticulosTraspasosSolicitud = articulosTraspasosSolicitud.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir =
          parseFloat(event.target.value) - parseFloat(i.surtido);
      }
      return i;
    });
    setArticulosTraspasosSolicitud(newArticulosTraspasosSolicitud);
    ActualizaTotales();
  };

  // const handleChangeInputCajas = (id, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i.cajas = event.target.value;
  //       i.cantidad =
  //         parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
  //       let totalParcial = i.cantidad * i.precio;
  //       i.total = totalParcial;
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);
  //   ActualizaTotales();
  // };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let KG = articulosTraspasosSolicitud.concat(values);
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TK);

    let importesExistentes = articulosTraspasosSolicitud.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG.toFixed(2));
  };

  const handleChangeInputPrecio = (id, value) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.precio = value;
        let totalParcial = i.cantidad * value;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    // if (
    //   inputFields.filter((e) => e.articulos == selectedArticulo._id).length > 0 ||
    //   articulosTraspasosSolicitud.filter((e) => e.articulos == selectedArticulo._id).length >
    //     0
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "El modelo ya fue capturado!",
    //     showConfirmButton: false,
    //   });
    //   const newInputFields = inputFields.map((i) => {
    //     if (id === i.id) {
    //       i.articulos = "";
    //     }
    //     return i;
    //   });
    //   setInputFields(newInputFields);
    // } else {
      articulos.map((a) => {
        if (a._id == selectedArticulo._id) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          let precio = a.venta;
          handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio);
        }
      });
    // }
  }

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let activos = articulosTraspasosSolicitud.filter((e) => e.is_active == "Si");
    let activos2 = activos.concat(inputFields);
    let cantidadActivos = activos2.map((c) => parseFloat(c.cantidad));
    let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TA);

    let totalActivos = activos2.map((c) => parseFloat(c.total));
    let TG = totalActivos.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG.toFixed(2));

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (selectedImpuesto * TG) / 100 +
        TG
    );
    setFechaModificado(endDate)
  }

  const saveTraspasosSolicitud = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalTraspasosSolicitud = inputFields.length + articulosTraspasosSolicitud.length;
    const URL_TRASPASOS_SOLICITUD_V2_EDIT = `${URL_TRASPASOS_SOLICITUD_V2}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_TRASPASOS_SOLICITUD_V2_EDIT,
          {
            total_general: parseFloat(total_general_edit).toFixed(2),
            total_cantidad: total_cantidad_edit,
            editArticulos: user.id,
            subTotal: parseFloat(subTotal).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            editado: "Si",
            // autorizadoApartado: "No",
            // autorizadoSurtido: "No",
            fechaModificado
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad != 0) {
              axios
                .post(
                  URL_ARTICULOS_TSOL_V2,
                  {
                    traspasosSolicitudV2: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total).toFixed(2),
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    autorizadoApartado: "Si",
                    autorizadoSurtido: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalTraspasosSolicitud = totalTraspasosSolicitud - 1;
                  if (totalTraspasosSolicitud == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Editar TraspasosSolicitud",
                        detalle: `${numero_traspasosSolicitud}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                });
            } else {
              totalTraspasosSolicitud = totalTraspasosSolicitud - 1;
              if (totalTraspasosSolicitud == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar TraspasosSolicitud",
                    detalle: `${numero_traspasosSolicitud}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            }
          });
          articulosTraspasosSolicitud.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_TSOL_V2}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total).toFixed(2),
                  pendiente_surtir: parseFloat(a.pendiente_surtir),
                  // autorizadoApartado: "No",
                  // autorizadoSurtido: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalTraspasosSolicitud = totalTraspasosSolicitud - 1;
                if (totalTraspasosSolicitud == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Editar TraspasosSolicitud",
                      detalle: `${numero_traspasosSolicitud}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function desautorizarApartado(id) {
    const URL_AUTORIZADO = `${URL_TRASPASOS_SOLICITUD_V2}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoApartado/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se liberará el inventario!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, liberar el inventario!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
              autorizoApartado: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Apartado",
                    detalle: `${numero_traspasosSolicitud} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se libero el inventario",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoApartado = "No";
                    i.autorizadoSurtido = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function autorizarApartado(id, almacen) {
    const URL_AUTORIZADO = `${URL_TRASPASOS_SOLICITUD_V2}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoApartado/${id}`;

    axios
      .get(`${URL_ARTICULOS_TSOL_V2}/surtir4/${id}/${almacen}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosAutorizar = response.data;
        setAllArticulosAutorizar(allArticulosAutorizar);

        let cantidadArticulos = allArticulosAutorizar.length;

        allArticulosAutorizar.map((a) => {
          if (a.cantidadTraspasosSolicitud > a.disponible) {
            return toggleNoDisponible();
          } else {
            cantidadArticulos = cantidadArticulos - 1;
            if (cantidadArticulos == 0) {
              Swal.fire({
                title: "Estas seguro?",
                text: "Se va a bloquear el inventario!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, bloquear!",
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .patch(
                      URL_AUTORIZADO,
                      {
                        autorizadoApartado: "Si",
                        autorizoApartado: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then((response) => {
                      axios
                        .patch(
                          URL_AUTORIZADO_HIJO,
                          {
                            autorizadoApartado: "Si",
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          axios.post(
                            URL_LOGS,
                            {
                              tipo: "Autorizar Apartado",
                              detalle: `${numero_traspasosSolicitud} ${fecha}`,
                              user: user.id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          );
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se Aparto",
                            showConfirmButton: false,
                            timer: 2000,
                          });
                          const newComments = comments.map((i) => {
                            if (id === i._id) {
                              i.autorizadoApartado = "Si";
                            }
                            return i;
                          });
                          setComments(newComments);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              });
            }
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function desautorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_TRASPASOS_SOLICITUD_V2}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se quitara la autorizacion de Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar autorizacion!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "No",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Surtido",
                    detalle: `${numero_traspasosSolicitud} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se quito la autorizacion",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function autorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_TRASPASOS_SOLICITUD_V2}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a autorizar Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, autorizar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Autorizar Surtido",
                    detalle: `${numero_traspasosSolicitud} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Autorizo",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "Si";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }


  function bajaArticulo(id) {
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_TSOL_V2}/autorizadoApartado/${idEdit}`;
    const temp = articulosTraspasosSolicitud.map((i) => {
      if (id === i.id) {
        i.is_active = "No";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de baja!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Baja!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG 

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_TSOL_V2}/${id}`,
            {
              is_active: "No",
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch TraspasosSolicitud
            axios
              .patch(
                `${URL_TRASPASOS_SOLICITUD_V2}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado:hoy
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                  axios
                    .patch(
                      URL_AUTORIZADO_HIJO,
                      {
                        autorizadoApartado: "No",
                        autorizadoSurtido: "No",
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    ).then(()=>{
                      const newAP = articulosTraspasosSolicitud.map((i) => {
                        if (id === i.id) {
                          i.is_active = "No";
                        }
                        return i;
                      });
                      setArticulosTraspasosSolicitud(newAP);
      
                      const newPed = comments.map((i) => {
                        if (idEdit === i._id) {
                          i.total_cantidad = TA;
                          i.total_general= TGT
                          i.subTotal= TG
                          i.iva= IT
                          i.autorizadoApartado= "No"
                          i.autorizadoSurtido= "No"
                        }
                        return i;
                      });
                      setComments(newPed);
      
                      Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Se dio de Baja",
                        showConfirmButton: false,
                        timer: 2000,
                      });
                      
                    }).catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });

              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch TraspasosSolicitud
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function altaArticulo(id) {
    const temp = articulosTraspasosSolicitud.map((i) => {
      if (id === i.id) {
        i.is_active = "Si";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de Alta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Alta!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG 

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_TSOL_V2}/${id}`,
            {
              is_active: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch TraspasosSolicitud
            axios
              .patch(
                `${URL_TRASPASOS_SOLICITUD_V2}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado:hoy
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((response) => {
                const newAP = articulosTraspasosSolicitud.map((i) => {
                  if (id === i.id) {
                    i.is_active = "Si";
                  }
                  return i;
                });
                setArticulosTraspasosSolicitud(newAP);

                const newPed = comments.map((i) => {
                  if (idEdit === i._id) {
                    i.total_cantidad = TA;
                    i.total_general= TGT
                    i.subTotal= TG
                    i.iva= IT
                    i.autorizadoApartado= "No"
                    i.autorizadoSurtido= "No"
                  }
                  return i;
                });
                setComments(newPed);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se dio de Alta",
                  showConfirmButton: false,
                  timer: 2000,
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch TraspasosSolicitud
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  const options2 = articulos.map((option) => {
    const junta = option.SKU + " " + option.nombre;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_traspasos_salida ? (
        <div className="card col-12">
          {!AbrirEditar ? (
            <>
              <Row>
                <Col md={8}>
                  {user.menu_traspasos_salida ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/TraspasosSolicitudCreate"
                    >
                      Nueva Solicitud
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nueva Solicitud
                    </Button>
                  )}
                  {/* <Button
                    size="sm"
                    href="/MenuInventarios"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button> */}
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado TraspasosSolicitud</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Traspasos Solicitud</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>

                <Col md={2}>
                  <Label>Autorizado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoApartado}
                    required
                    onChange={(e) => {
                      setAutorizadoApartado(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Autorizado Surtir</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoSurtido}
                    required
                    onChange={(e) => {
                      setAutorizadoSurtido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Status</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={status}
                    required
                    onChange={(e) => {
                      setStatus(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Abierto">Abierto</option>
                    <option value="Cerrado">Cerrado</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedAreaSalida}
                      onChange={(e) => {
                        setSelectedAreaSalida(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          if (a._id != AREAS_GENERAL) {
                                return <option value={a._id}>{a.name}</option>;
                          }
                        })}
                    </Input>
                  </td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedAreaDestino}
                      onChange={(e) => {
                        setSelectedAreaDestino(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          if (a._id != AREAS_GENERAL) {
                                return <option value={a._id}>{a.name}</option>;
                          }
                        })}
                    </Input>
                  </td>
                </tr>
                <tbody>
                  {commentsData.map((a) => {
                    if(a.activo == "No"){
                      return (
                        <tr style={{ backgroundColor: "#ed8c8c" }}>
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{a.fecha}</td>
                          <td>{a.numeroSolicitud}</td>
                          <td>{a.areaSalidaName}</td>
                          <td>{a.areaDestinoName}</td>
                          <td>
                          </td>
                          <td align="right">
                          </td>
                          <td>CANCELADO</td>
                          <td></td>
                        </tr>
                      );
                    }else if (a.autorizadoSurtido == "Si") {
                      return (
                        <tr style={{ backgroundColor: "#64e379" }}>
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{a.fecha}</td>
                          <td>{a.numeroSolicitud}</td>
                          <td>{a.areaSalidaName}</td>
                          <td>{a.areaDestinoName}</td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.total_cantidad
                            )}
                          </td>
                          <td>
                            {user.menu_traspasos_salida && (user.areas == AREAS_GENERAL || a.idAreaDestino == user.areas) ? (
                              <div>
                                {a.surtido == "No" &&
                                user.menu_traspasos_salida &&
                                a.status == "Abierto" ? (
                                  a.autorizadoApartado == "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarApartado(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-up"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) =>
                                          autorizarApartado(a._id, a.idAreaSalida)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-down"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.status == "Abierto" ? (
                                  <Button
                                    size="sm"
                                    className="btn"
                                    color="danger"
                                    onClick={(e) =>
                                      PDFOC(
                                        a.fecha,
                                        a.total_cantidad,
                                        a.total_general,
                                        a.observaciones,
                                        // a.transportista,
                                        // a.unidad,
                                        a.numero,
                                        a.impuestos,
                                        a._id,
                                        a.areaSalidaName,
                                        a.areaDestinoName,
                                        a.autorizadoApartado,
                                        a.autorizadoSurtido,
                                        a.numeroSolicitud
                                      )
                                    }
                                  >
                                    <i class="far fa-file-pdf"></i>
                                  </Button>
                                ) : undefined}

                                {a.surtido == "No" &&
                                user.menu_traspasos_salida &&
                                a.status == "Abierto" ? (
                                  a.autorizadoApartado == "Si" ? (
                                    a.autorizadoSurtido == "Si" ? (
                                      <span>
                                        <Button
                                          color="primary"
                                          id="Baja"
                                          onClick={(e) =>
                                            desautorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i class="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : (
                                      <span>
                                        <Button
                                          color="danger"
                                          onClick={(e) =>
                                            autorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i class="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    )
                                  ) : a.autorizadoSurtido == "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id)
                                        }
                                        size="sm"
                                        disabled
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) => autorizarSurtido(a._id)}
                                        size="sm"
                                        disabled
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.surtido == "No" && user.menu_traspasos_salida ? (
                                  <>
                                  <StatusMultiple
                                    idStatus={a._id}
                                    status={a.status}
                                    URL_STATUS={URL_TRASPASOS_SOLICITUD_V2}
                                    hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                                  />
                                  <BajaMultiple
                                  idStatus={a._id}
                                  is_active={a.activo}
                                  URL_BAJA={URL_TRASPASOS_SOLICITUD_V2}
                                  hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                                  />
                                </>
                                ) : undefined}

                              </div>
                            ) : undefined}
                          </td>
                          <td>
                            {a.surtido == "No" && (user.areas == AREAS_GENERAL || a.idAreaDestino == user.areas)? (
                              a.status == "Abierto" && a.activo == "Si" ? (
                                <div>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      jalaInfo(
                                        // a.fecha,
                                        // a.total_cantidad,
                                        // a.total_general,
                                        a.observaciones,
                                        // a.transportista,
                                        // a.unidad,
                                        // a.numeroSolicitud,
                                        a.numeroSolicitud,
                                        // a.numero,
                                        // a.impuestos,
                                        a._id,
                                        // a.idAreaSalida
                                      )
                                    }
                                  >
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      EditArticulos(
                                        a._id,
                                        a.numero,
                                        a.impuestos,
                                        a.subTotal,
                                        a.iva,
                                        a.total_general,
                                        a.total_cantidad,
                                        a.surtido,
                                        a.idAreaSalida,
                                        a.fechaModificado
                                      )
                                    }
                                  >
                                    <i class="fas fa-cart-plus"></i>
                                  </Button>
                                </div>
                              ) : undefined
                            ) : undefined}
                          </td>
                          <td>
                            { user.menu_traspasos_salida  && (user.areas == AREAS_GENERAL || a.idAreaDestino == user.areas) ? (
                              <>
                              <StatusMultipleSurtido
                                idStatus={a._id}
                                status={a.surtido}
                                URL_STATUS={URL_TRASPASOS_SOLICITUD_V2}
                                hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                              />
                                  </>
                            ) : undefined}
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr>
                          <td>{a.numero}</td>
                          <td>{a.fecha}</td>
                          <td>{a.numeroSolicitud}</td>
                          <td>{a.areaSalidaName}</td>
                          <td>{a.areaDestinoName}</td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.total_cantidad
                            )}
                          </td>
                          <td>
                            {user.menu_traspasos_salida ? (
                              <div>
                                {a.surtido == "No" &&
                                user.menu_traspasos_salida &&
                                a.status == "Abierto" ? (
                                  a.autorizadoApartado == "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarApartado(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-up"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) =>
                                          autorizarApartado(a._id, a.idAreaSalida)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-down"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.status == "Abierto" ? (
                                  <Button
                                    size="sm"
                                    className="btn"
                                    color="danger"
                                    onClick={(e) =>
                                      PDFOC(
                                        a.fecha,
                                        a.total_cantidad,
                                        a.total_general,
                                        a.observaciones,
                                        // a.transportista,
                                        // a.unidad,
                                        a.numero,
                                        a.impuestos,
                                        a._id,
                                        a.areaSalidaName,
                                        a.areaDestinoName,
                                        a.autorizadoApartado,
                                        a.autorizadoSurtido,
                                        a.numeroSolicitud
                                      )
                                    }
                                  >
                                    <i class="far fa-file-pdf"></i>
                                  </Button>
                                ) : undefined}

                                {a.surtido == "No" &&
                                user.menu_traspasos_salida &&
                                a.status == "Abierto" ? (
                                  a.autorizadoApartado == "Si" ? (
                                    a.autorizadoSurtido == "Si" ? (
                                      <span>
                                        <Button
                                          color="primary"
                                          id="Baja"
                                          onClick={(e) =>
                                            desautorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i class="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : (
                                      <span>
                                        <Button
                                          color="danger"
                                          onClick={(e) =>
                                            autorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i class="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    )
                                  ) : a.autorizadoSurtido == "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id)
                                        }
                                        size="sm"
                                        disabled
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) => autorizarSurtido(a._id)}
                                        size="sm"
                                        disabled
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.surtido == "No" && user.menu_traspasos_salida ? (
                                  <>
                                  <StatusMultiple
                                    idStatus={a._id}
                                    status={a.status}
                                    URL_STATUS={URL_TRASPASOS_SOLICITUD_V2}
                                    hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                                  />
                                  <BajaMultiple
                                  idStatus={a._id}
                                  is_active={a.activo}
                                  URL_BAJA={URL_TRASPASOS_SOLICITUD_V2}
                                  hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                                  />
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          <td>
                            {a.surtido == "No" ? (
                              a.status == "Abierto" && a.activo == "Si" ? (
                                <div>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      jalaInfo(
                                        // a.fecha,
                                        // a.total_cantidad,
                                        // a.total_general,
                                        a.observaciones,
                                        // a.transportista,
                                        // a.unidad,
                                        // a.numeroSolicitud,
                                        a.numeroSolicitud,
                                        // a.numero,
                                        // a.impuestos,
                                        a._id,
                                        // a.idAreaSalida
                                      )
                                    }
                                  >
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      EditArticulos(
                                        a._id,
                                        a.numero,
                                        a.impuestos,
                                        a.subTotal,
                                        a.iva,
                                        a.total_general,
                                        a.total_cantidad,
                                        a.surtido,
                                        a.idAreaSalida,
                                        a.fechaModificado
                                      )
                                    }
                                  >
                                    <i class="fas fa-cart-plus"></i>
                                  </Button>
                                </div>
                              ) : undefined
                            ) : undefined}
                          </td>
                          <td>
                            {user.menu_traspasos_salida ? (
                              <StatusMultipleSurtido
                                idStatus={a._id}
                                status={a.surtido}
                                URL_STATUS={URL_TRASPASOS_SOLICITUD_V2}
                                hijo={`${URL_ARTICULOS_TSOL_V2}/baja`}
                              />
                            ) : undefined}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </>
          ) : (
            <div className="card container col-md-12">
              <h4>Editar TraspasosSolicitud {numero_traspasosSolicitud}</h4>
              <Form onSubmit={saveTraspasosSolicitud}>
                <Row>
                

                  <Col md={1}>
                    <Label>Piezas</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Piezas"
                      value={total_cantidad_edit}
                      required
                      disabled
                    />
                  </Col>

                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulos</Label>
                  </Col>
                  {/* {areaSalida == AREAS_CEDIS ? (
                    <Col md={1}>
                      <Label className="mr-sm-2">Disponible CEDIS</Label>
                    </Col>
                  ) : undefined} */}
                  {/* <Col md={1}>
                    <Label className="mr-sm-2">Cajas</Label> 
                  </Col>*/}
                  <Col md={1}>
                    <Label className="mr-sm-2">Pzas Caja</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Surtido</Label>
                  </Col>

                </Row>

                {articulosTraspasosSolicitud.map((ao) => (
                  <div key={ao.id}>
                    <Row>
                      {ao.surtido == 0 ? (
                        <Col md={2}>
                          <Input
                            name="articulos"
                            type="select"
                            value={ao.articulos}
                            required
                            onChange={(event) => {
                              BuscaArticuloExistentes(ao.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                              .map((a) => {
                                return (
                                  <option value={a._id}>
                                    {a.SKU} {a.nombre}
                                  </option>
                                );
                              })}
                          </Input>
                        </Col>
                      ) : (
                        <Col md={2}>
                          <Input
                            name="articulos"
                            type="select"
                            value={ao.articulos}
                            required
                            disabled
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                              .map((a) => {
                                return (
                                  <option value={a._id}>
                                    {a.SKU} {a.nombre}
                                  </option>
                                );
                              })}
                          </Input>
                        </Col>
                      )}

                      {/* {areaSalida == AREAS_CEDIS ? (
                        <Col md={1}>
                          <Input  type="select" disabled>
                            {inventarios.map((a) => {
                              if (ao.articulos == a.idArticulo) {
                                return (
                                  <option value={a._id}>{a.disponible}</option>
                                );
                              }
                            })}
                          </Input>
                        </Col>
                      ) : undefined} */}

                      {/* <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="cajas"
                          type="string"
                          value={ao.cajas}
                          onChange={(event) =>
                            handleChangeInputCajasExistentes(ao.id, event)
                          }
                        ></Input>
                      </Col> */}

                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="piezasPorCaja"
                          type="string"
                          value={ao.piezasPorCaja}
                          disabled
                        ></Input>
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="cantidad"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={ao.cantidad}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidadExistentes(ao.id, event)
                          }
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="surtido"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="surtido"
                          value={ao.surtido}
                          disabled
                        />
                      </Col>

                    
                      <Col md={1}>
                        {ao.is_active == "Si" ? (
                          <Button
                            color="primary"
                            id="Baja"
                            onClick={(e) => {
                              bajaArticulo(ao.id);
                            }}
                            size="sm"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                        ) : (
                          <Button
                            color="danger"
                            onClick={(e) => {
                              altaArticulo(ao.id);
                            }}
                            size="sm"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}

                {/* Agregar mas articulos */}

                {inputFields.map((inputField) => (
                  <div key={inputField.id}>
                    <Row>
                      <Col md={2}>
                        {/* <Input
                          // bsSize="sm"
                          name="articulos"
                          type="select"
                          value={inputField.articulos}
                          required
                          onChange={(event) => {
                            BuscaArticulo(inputField.id, event);
                          }}
                        >
                          <option value="0">Selecciona</option>
                          {articulos
                            .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                            .map((a) => {
                              return (
                                <option value={a._id}>
                                  {a.SKU} {a.nombre}
                                </option>
                              );
                            })}
                        </Input> */}


<Autocomplete
                    size="small"
                    value={inputField.articulosNombre}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticulo(inputField.id, selectedArticulo);
                    }}
                    options={options2.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.SKU} {option.nombre}
                      </React.Fragment>
                    )}
                  />
                      </Col>

                      {/* {areaSalida == AREAS_CEDIS ? (
                        <Col md={1}>
                          <Input  type="select" disabled>
                            {inventarios.map((a) => {
                              if (inputField.articulos == a.idArticulo) {
                                return (
                                  <option value={a._id}>{a.disponible}</option>
                                );
                              }
                            })}
                          </Input>
                        </Col>
                      ) : undefined} */}

                      {/* <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="cajas"
                          type="string"
                          value={inputField.cajas}
                          onChange={(event) =>
                            handleChangeInputCajas(inputField.id, event)
                          }
                        ></Input>
                      </Col> */}
                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="piezasPorCaja"
                          type="string"
                          value={inputField.piezasPorCaja}
                          disabled
                        ></Input>
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="cantidad"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={inputField.cantidad}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidad(inputField.id, event)
                          }
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="surtido"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="0"
                          disabled
                        />
                      </Col>

                      <Col>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          disabled={inputFields.length === 1}
                          onClick={() => handleRemoveFields(inputField.id)}
                          tabindex="-1"
                        >
                          <i class="fas fa-minus"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          onClick={handleAddFields}
                          tabindex="-1"
                        >
                          <i class="fas fa-plus"></i>
                        </Button>
                      </Col>
                    </Row>
                  </div>
                ))}
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  onClick={(e) => setAbrirEditar(false)}
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </div>
          )}
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar TraspasosSolicitud {numero_traspasosSolicitud}</h4>
        </ModalHeader>
        <ModalBody>
          {/* <Row>
           

            <Col md={3}>
            <Label>Surtir de Almacen</Label>
              <Input
                type="select"
                value={selectedAreaSalidaEdit}
                onChange={(e) => {
                  setSelectedAreaSalidaEdit(e.target.value);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
              </Input>
            </Col>

          </Row> */}
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                Transportista
              </Label>
              <Input
                type="text"
                placeholder="transportista"
                value={transportista}
                required
                onChange={(e) => {
                  setTransportista(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                Unidad
              </Label>
              <Input
                type="text"
                placeholder="unidad"
                value={unidad}
                required
                onChange={(e) => {
                  setUnidad(e.target.value);
                }}
              />
            </Col> */}
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Numero Solicitud
              </Label>
              <Input
                type="text"
                placeholder="numeroSolicitud"
                value={numeroSolicitud}
                required
                onChange={(e) => {
                  setNumeroSolicitud(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editTraspasosSolicitud}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>


     <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

      <Modal size="sm" isOpen={modalNoDisponible} toggle={toggleNoDisponible}>
        <ModalHeader toggle={toggleNoDisponible}>
          <h4>No hay Inventario Disponible</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Solicitud</th>
              <th>Disponible</th>
            </tr>

            {allArticulosAutorizar.map((a) => {
              if (a.disponible < a.cantidadTraspasosSolicitud) {
                return (
                  <tr style={{ backgroundColor: "#ed8c8c" }}>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadTraspasosSolicitud)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadTraspasosSolicitud)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              }
            })}
          </Table>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoTraspasosSolicitudV2;
